import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { AccountSetPasswordInput, AccountSetPasswordPayload } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TVariables = AccountSetPasswordInput;
type TData = AccountSetPasswordPayload;

export const useAccountPassword = (
  options: Omit<UseMutationOptions<TData, TGenericError, TVariables, unknown>, 'mutationFn'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    mutation accountSetPassword($input: AccountSetPasswordInput!) {
      accountSetPassword(input: $input) {
        success
        errors
        errorCode
      }
    }
  `;

  return useMutation<TData, TGenericError, TVariables, unknown>({
    mutationFn: (input: TVariables): Promise<TData> =>
      client.request({
        data: {
          gql: graphql,
          variables: { input }
        }
      }),
    ...options
  });
};
